import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { useLocation } from "react-router-dom";
import "./viewpayment.css";
import BASEURL from "../../../pages/Utils/Baseurl";
import request from "graphql-request";
import { getPaymentBalanceById } from "./PaymentBalanceData";
import { useState } from "react";

const ViewPaymentBalance = () => {
  const [data, setData] = useState(null);
  const location = useLocation();

  const rowId = location?.state?.rowId;

  useEffect(() => {
    if (rowId) {
      fetchById();
    }
  }, [rowId]);

  const fetchById = async () => {
    try {
      const response = await request(BASEURL, getPaymentBalanceById, {
        id: rowId,
      });

      const success = response?.getPaymentBalance?.success;
      if (success) {
        setData(response?.getPaymentBalance?.data[0]);
      } else {
        setData(null);
      }

      console.log(response, "response");
    } catch (error) {}
  };

  const formatStatus = (status, amount) => {
    if (status === "Completed") return "Paid";
    if (parseFloat(amount) > 0) return "Partially Paid";
    return "Unpaid";
  };

  return (
    <DashboardLayout>
      <div className="receipt-container">
        <h2>Cash Receipt</h2>

        <div className="customer-details">
          <p>
            <strong>Customer Code:</strong> {data?.customerCode}
          </p>
          <p>
            <strong>Customer Name:</strong> {data?.customerName}
          </p>
          <p>
            <strong>Credit Limit:</strong> {data?.creditLimit}
          </p>
          <p>
            <strong>Category:</strong> {data?.category}
          </p>
          <p>
            <strong>Age Of Invoice:</strong> {data?.ageOfInvoice}
          </p>
          <p>
            <strong>N days :</strong> {data?.ndays}
          </p>
          <p>
            <strong>Total Paid Amount:</strong> {data?.amountPaid}
          </p>
        </div>

        <h3>Invoice Details</h3>
        <table className="invoice-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Invoice Number</th>
              <th>SO Date</th>
              <th>Payment Receivable</th>
              <th>Amount Paid</th>
              <th>Outstanding Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data?.invoices.map((inv, idx) => (
              <tr key={inv.id}>
                <td>{idx + 1}</td>
                <td>{inv.invoiceNumber}</td>
                <td>{inv.soDate}</td>
                <td>{parseFloat(inv.balance).toFixed(2)}</td>
                <td>
                  {inv?.partialPaidAmount == "None"
                    ? "Unpaid"
                    : parseFloat(inv.partialPaidAmount).toFixed(2)}
                </td>
                <td>{parseFloat(inv.remainingAmount).toFixed(2)}</td>
                <td
                  style={{
                    color:
                      inv?.paymentStatus == "Completed"
                        ? "#2a9941"
                        : inv?.paymentStatus == "Incompleted"
                        ? "red"
                        : "orange",
                    fontWeight: "600",
                  }}
                >
                  {inv?.paymentStatus}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
};

export default ViewPaymentBalance;
